"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _Theme = _interopRequireDefault(require("../../Theme"));
var _MobileDropDownOption = _interopRequireDefault(require("../MobileDropDownOption"));
var _MobileDropdownOptions = require("./MobileDropdownOptions.propTypes");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function (e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != typeof e && "function" != typeof e) return {
    default: e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n.default = e, t && t.set(e, n), n;
}
const MobileDropdownOptions = props => {
  const {
    options,
    optionsConfig,
    markSelectedOnPress,
    selectedItem,
    theme,
    customProperties
  } = props;
  const themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  const handlePress = value => {
    markSelectedOnPress(value);
  };
  const getMain = () => {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, options &&
    // eslint-disable-next-line react/prop-types
    options.map((option, index) => /*#__PURE__*/_react.default.createElement(_MobileDropDownOption.default, (0, _extends2.default)({}, option, optionsConfig, {
      onOptionPress: handlePress,
      key: option.value,
      itemSelected: option.value === selectedItem,
      theme: theme,
      customProperties: {
        id: "mobile-dropdown-option-".concat(index),
        ...customProperties
      }
    }))));
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
MobileDropdownOptions.propTypes = _MobileDropdownOptions.MobileDropdownOptionsPropTypes.PropTypes;
MobileDropdownOptions.defaultProps = _MobileDropdownOptions.MobileDropdownOptionsPropTypes.DefaultProps;
var _default = exports.default = MobileDropdownOptions;